import { discard as discardCard, shouldFetch } from 'actions/cards';

import { begin } from 'actions/storylet';
import classnames from 'classnames';

import Buttonlet from 'components/Buttonlet';

import makeTooltipData from 'components/Cards/utils/makeTooltipData';
import Loading from 'components/Loading';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';
import { ICard } from 'types/cards';
import SmallCard from './SmallCard';

type OwnProps = {
  data: ICard,
  dispatch: Function,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

type State = {
  isWorking: boolean,
};

class SmallCardContainer extends Component<Props, State> {
  static displayName = 'SmallCardContainer';

  mounted = false;

  state = {
    isWorking: false,
  };

  componentDidMount = () => {
    this.mounted = true;
  };

  componentWillUnmount = () => {
    this.mounted = false;
  };

  discard = () => {
    const { data, dispatch } = this.props;
    dispatch(discardCard(data.eventId));
  };

  play = () => {
    const { data, dispatch} = this.props;
    this.setState({ isWorking: true });

    if(data.isAutofire){
      dispatch(shouldFetch());
    }

    dispatch(begin(data.eventId))
      .then(() => {
        if (this.mounted) {
          this.setState({ isWorking: false });
        }
      });
  };

  render() {
    const { data, isChoosing, isFetching } = this.props;
    const {
      eventId,
      name,
      stickiness,
      teaser,
    } = data;
    const { isWorking } = this.state;

    const { ...tooltipData } = data;

    const lockedByOtherCard = isChoosing && !isWorking;

    return (
      <div
        className={classnames(
          'branch',
          'small-card-container',
          isFetching && 'card--fetching',
          lockedByOtherCard && 'storylet--semi-transparent',
        )}
        data-event-id={eventId}
      >
        <div className="media__left small-card__left">
          <SmallCard
            cardData={data}
            tooltipData={makeTooltipData({ data: tooltipData, action: this.play })}
          />
        </div>
        <div className="media__body small-card__body">
          <div className="small-card__title-and-buttonlet">
            {stickiness !== 'Sticky' && (
              <div className="branch__plan-buttonlet">
                <Buttonlet
                  type="delete"
                  onClick={this.discard}
                />
              </div>
            )}
            <h2
              className="media__heading heading heading--3"
              dangerouslySetInnerHTML={{ __html: name }}
            />
          </div>
          <div className="small-card__teaser" dangerouslySetInnerHTML={{ __html: teaser }} />
          <div className="buttons">
            <button
              className={classnames(
                'button button--primary button--margin',
                lockedByOtherCard && 'button--disabled',
              )}
              onClick={this.play}
              type="button"
            >
              {isWorking ? <Loading spinner small /> : 'Play'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  cards: { isFetching },
  storylet: { isChoosing },
}: IAppState) => ({
  isChoosing,
  isFetching,
});

export default connect(mapStateToProps)(SmallCardContainer);